<template>
    <div v-show="show" :class="wrapperCssClass">
        <slot>
            <label :for="id" v-if="showValidation || label">
                <span v-if="label" v-text="label"></span>
                <span class="validation" v-show="errors.has(name)" v-if="showValidation">
                    <span
                        v-for="(message, index) in validation"
                        v-show="errors.display(name, index)"
                        v-text="message"
                    ></span>
                </span>
            </label>
        </slot>
        <select
            :name="name"
            :id="id"
            :maxlength="maxlength"
            :class="invalidClass"
            :style="cssStyle"
            :disabled="disabled"
            @change="change($event.target.value)"
            v-focus="focus"
        >
            <option value v-if="placeholder">{{ placeholder }}</option>
            <option
                v-for="option in options"
                :value="option.value"
                :selected="isSelected(option.value)"
            >
                {{ option.name }}
            </option>
        </select>
    </div>
</template>
<script>
    import FormInputMixin from '../../../mixins/Form/SingleSelect';
    export default {
        mixins: [FormInputMixin]
    }
</script>